const danhSachVanBan = (state) => state.danhSachVanBan;
const vanBanDangCapNhat = (state) => state.vanBanDangCapNhat;
const vanBanId = (state) => state.vanBanId;
const danhSachLoaiSoVanBan = (state) => state.danhSachLoaiSoVanBan;
const danhSachSoVanBan = (state) => state.danhSachSoVanBan;
const danhSachLoaiVanBanPaging = (state) => state.danhSachLoaiVanBanPaging;
const saoChepVanBan = (state) => state.saoChepVanBan;
const danhSachLoaiVanBanMacDinh = (state) => state.danhSachLoaiVanBanMacDinh;
const infoSoDen = (state) => state.infoSoDen
const infoSoPhu = (state) => state.infoSoPhu
export default {
  danhSachVanBan,
  vanBanDangCapNhat,
  vanBanId,
  danhSachLoaiSoVanBan,
  danhSachSoVanBan,
  danhSachLoaiVanBanPaging,
  saoChepVanBan,
  danhSachLoaiVanBanMacDinh,
  infoSoDen,
  infoSoPhu
};
